var XPortal = XPortal || {};
XPortal.DynamicFilters = (function () {
    var self = {
        AutoApplyTimeouts: [],
        SummaryViewModels: [],
        GridFilterSetsPairs: {},
        collapseAfterSearch: true,
        fsetSelector: ".dynamic-filter-set",
        fsetSectionSelector: ".dynamic-filter-section",
        summaryItemSelector: ".dynamic-filter-summary",
        summaryBlockSelector: ".dynamic-filter-summary-block",
        itemControlSelector: ".dynamic-filter-item-control",
        groupControlSelector: ".dynamic-filter-group",
        controlSelector: ".data-datepicker",
        controlWithTimeSelector: ".data-datetimepicker",
        itemsWithEditorSelector: ".dfilter-item",
        groupMoreBtnWrp: ".dynamic-items-more-wrp",
        SearchTimeout: null,
        Init: function (container) {
            const $container = $(container ? container : "body");
            // We need to check if there are any filter sets on the page before init them
            const allFilterSets = $container.find(self.fsetSelector);
            const isDetailPage = $container.is(XPortal.Main.DetialFormSelector) || $container.find(XPortal.Main.DetialFormSelector).length;

            self.HandleResize($container);

            if (allFilterSets.length > 0) {
                self.InitModelFor($container, allFilterSets);
                self.InitControlsFor($container, allFilterSets);
                makeGridFilterSetsPairs($container, allFilterSets);
                $(document).off("click", ".dynamic-filter-apply-button", onApply).on("click", ".dynamic-filter-apply-button", onApply);
                $(document).off("click", ".dynamic-filter-reset-button", onReset).on("click", ".dynamic-filter-reset-button", onReset);
            } else if (!isDetailPage) {
                const observer = new MutationObserver(() => {
                    const allFilterSets = $container.find(self.fsetSelector);
                    if (allFilterSets.length) {
                        self.InitModelFor($container, allFilterSets);
                        self.InitControlsFor($container, allFilterSets);
                        makeGridFilterSetsPairs($container, allFilterSets);
                        $(document).off("click", ".dynamic-filter-apply-button", onApply).on("click", ".dynamic-filter-apply-button", onApply);
                        $(document).off("click", ".dynamic-filter-reset-button", onReset).on("click", ".dynamic-filter-reset-button", onReset);
                        observer.disconnect();
                        self.updateSectionColStyleClasses();
                    }
                });
                observer.observe($container[0], { childList: true, subtree: true });
            }
            if (allFilterSets.length < 1) self.InitControlsFor($container, allFilterSets);
        },
        HandleResize: function ($container) {
            let resizeTimeout;
            
            $(window).off('resize.dynamicFilters').on('resize.dynamicFilters', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    $container.find('.xsection_apply-btn-in-header.col-1, .xsection_apply-btn-in-header.col-2, .xsection_apply-btn-in-header.col-3, .xsection_apply-btn-in-header.col-4').each(function() {
                        checkWidthAndMoveElements($(this));
                    });

                }, 100); 
            });
        },
        InitModelFor: function ($container, allFilterSets) {
            
            allFilterSets.each(function (ix1, element) {
                const $fset = $(element);
                let lfunction = function (e, r) { lookupBeforeRequest($fset, e, r.data, r); };
                $fset.find(self.itemControlSelector).off("lookup.beforeRequest", lfunction).on("lookup.beforeRequest", lfunction);
                let modelName = XPortal.Store.getModelName(element.id);
                let sttgs = XPortal.Utils.readJsonStr($fset.attr("data-settings"), {});
                let fieldsMeta = _.map($fset.find(self.itemsWithEditorSelector), (x, xi) => getFsetFieldItemObj(x, modelName, sttgs, xi, $fset));
                const selector = "#" + element.id;
                const modelPath = XPortal.Store.GetModelPath($(selector), modelName);
                XPortal.Store.AppStore.dispatch({
                    type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: { UniqueId: XPortal.Utils.guid(), Fields: [] }, model: {
                        modelPath, entityApplied: {}, isFilterSet: true, skipSaving: true, selector, NodeId: (sttgs || {}).nodeId, IsCreating: false, settings: sttgs, fields: fieldsMeta, IsApplied: false, searchmeta: getSummarySearchMeta($fset)
                    }
                });
            });
        },
        InitControlsFor: function ($container, allFilterSets) {
            initSummaries($container, allFilterSets);
            allFilterSets.each(function (ix1, element) {
                const $fset = $(element);
                let modelName = XPortal.Store.getModelName(element.id);
                XPortal.Main.InitEditControls($fset);
                subscribeForChanges($fset, modelName);
            });
            XPortal.ToolTips.Init($container);
        },
        InitDropDownItemTooltip: function ($el) {
            const list = $el.parent().find(".k-multiselect-wrap ul li");
            list.each(ind => {
                const tooltip = $(list[ind]).kendoTooltip({
                    position: 'bottom',
                    offset: -10,
                    showAfter: 1500,
                    content: function (e) {
                        const $target = $(e.sender.element);
                        const i = $target.find("span");
                        const iElem = $target.find("span")[0];

                        const content = i.text() || "";
                        const textWidth = getInputTextWidth(iElem, content);
                        const inputWidth = iElem.clientWidth;

                        if (!textWidth || !content.length || inputWidth > textWidth + 8)
                            return;

                        return content;
                    },
                    show: function (e) {
                        const $target = $(e.sender.element);
                        const i = $target.find("span");
                        const iElem = $target.find("span")[0];

                        const content = i.text() || "";
                        const textWidth = getInputTextWidth(iElem, content);
                        const inputWidth = iElem.clientWidth;

                        if (!textWidth || !content.length || inputWidth > textWidth + 8) {
                            tooltip.refresh();
                            return;
                        }

                        const tooltipElement = this.popup.element;
                        const tooltipWidth = $target.outerWidth();
                        const targetOffset = $target.offset();
                        const targetCenterX = targetOffset.left + ($target.outerWidth() / 2);

                        // Set tooltip dimensions and position

                        tooltipElement.parent('.k-animation-container').css({
                            'width': `${tooltipWidth}px`,
                        });

                        tooltipElement.find('.k-tooltip-content').html(content);

                        tooltipElement.addClass('validation-tooltip');
                        tooltipElement.addClass('filter-tooltip');

                        const factTooltipWidth = tooltipElement[0].clientWidth;
                        tooltipElement.parent('.k-animation-container').css({
                            'left': `${targetCenterX - factTooltipWidth + factTooltipWidth / 2}px`,
                        });

                        const $calloutElement = tooltipElement.find('.k-callout');
                        $calloutElement.css('left', `${factTooltipWidth / 2}px`);
                    }
                }).data("kendoTooltip");
            });
        },
        GetFor: function (gridId, srequest) {
            const gfrel = XPortal.DynamicFilters.GridFilterSetsPairs[gridId];
            let dFilters = [];
            if (!gfrel || !gfrel.fsets.length) return dFilters;
            const fltrSets = gfrel.fsets;
            fltrSets.forEach(function (fset) {
                let fsmodel = XPortal.Store.GetModelByName(fset.modelName);
                if (!fsmodel.model.IsApplied) return;
                let oentity = excludeDisplayValue(XPortal.Store.ConvertEditEntityToSave(fsmodel.model.entityApplied, fsmodel.ParentInfo));
                var fentity = XPortal.GridInlineEditing.DateTimeFieldProcessing(Object.assign({}, oentity));
                dFilters.push({ id: fset.nodeId, uid: fset.id, entity: fentity, settings: fsmodel.model.settings });
            });
            updateGridRequestKey(gridId, gridId, srequest);
            return dFilters;
        },
        UpdateLookupsAndPickers: function ($fset, pickers, lookups) {
            self.UpdateLookups($fset, lookups);
            self.UpdatePickers($fset, pickers);
        },
        UpdateLookups: function ($fset, lookups) {
            if (!lookups && $fset) lookups = $fset.find("input.dfilter-lookup,select.dfilter-lookup");
            if (!lookups.length) return;

            lookups.each(function (i, el) {
                var $el = $(el);
                let kbox = $el.data("kendoComboBox") || $el.data("kendoMultiSelect");
                if (kbox && kbox.dataSource)
                    kbox.dataSource.read();
            });
        },
        UpdatePickers: function ($fset, pickers, isShowAll) {
            if (!pickers && $fset) pickers = $fset.find(".data-xvalue-picker");
            if (!pickers.length) return;

            pickers.each(function (i, el) {
                $(el).trigger("dataSource.read", { data: { grids: getFsetGridsInfo($fset) }, isShowAll: isShowAll });
            });
        },
        RestoreFrom: function (ginfo, dynamicSettings) {
            const gfrel = XPortal.DynamicFilters.GridFilterSetsPairs[ginfo.nodeId];
            if (!gfrel || !gfrel.fsets.length) return;
            gfrel.fsets.forEach(function (fset) {
                let fsmodel = XPortal.Store.GetModelByName(fset.modelName);
                _.each(fsmodel.model.fields, f => {
                    XPortal.Store.DispatchNoAutoSave(fset.modelName, f.field, null, f.type, true);
                });
                fsmodel.model.IsApplied = true;
                fsmodel.model.entityApplied = Object.assign({}, fsmodel.entity);
                refreshSummaryModel(fset.modelName);
            });
            if (dynamicSettings)
                dynamicSettings.forEach(x => {
                    _.each(XPortal.Store.GetState().pageModels, d => {
                        if (d.model && d.model.NodeId == x.id && x.entity && x.entity.Fields) {
                            _.each(x.entity.Fields, f => {
                                XPortal.Store.DispatchByName(d.model.modelName, f.Field, f.Data, true);
                            });
                            d.model.IsApplied = true;
                            d.model.entityApplied = Object.assign({}, d.entity);
                            refreshSummaryModel(d.model.modelName);
                        }
                    });
                });
            return setTimeout(function () {
                ginfo.kgrid.dataSource.read();
            }, 300);
        },
        updateSectionColStyleClasses: function () {
            const items = Array.from(document.querySelectorAll('.xfiltersummarysection'));
            const rows = new Map();

            items.forEach((el) => {
                const top = Math.round(el.getBoundingClientRect().top);
                if (!rows.has(top)) {
                    rows.set(top, []);
                }
                rows.get(top).push(el);
            });

            let maxItemsPerRow = 0;
            for (const rowItems of rows.values()) {
                if (rowItems.length > maxItemsPerRow) {
                    maxItemsPerRow = rowItems.length;
                }
            }

            let rowIndex = 0;
            for (const rowItems of rows.values()) {
                rowItems.forEach((el, index) => {
                    el.classList.add(`xfiltersummarysection_row-${rowIndex}`);

                    if ((index + 1) === maxItemsPerRow && rowItems.length === maxItemsPerRow) {
                        el.classList.add('xfiltersummarysection_last_in_row');
                    }
                });
                rowIndex++;
            }
        },
    };
    function getFsetFieldItemObj(el, mname, sttgs, elix, $fset) {
        return Object.assign(XPortal.Main.GetSettingsFor(el), {
            modelName: mname,
            hideTitle: true, hideCount: true,
            showTitle: false,
            isHidden: true,
            value: [],
            count: 0
        });
    };
    function getSummarySearchMeta($fset) {
        let psummary = $fset.closest(self.summaryBlockSelector);
        let bh = $fset.find(".block-header").text();
        if (psummary.length < 1) return bh;
        $fset.closest(".xfiltersummarysection").each((ix, x) => {
            if (psummary.has($(x)))
                bh = bh + " " + $(x).find(".block-header").text();
        });
        return bh;
    };
    function makeGridFilterSetsPairs($container, allFilterSets) {
        const grids = $container.find(".entity-grid");
        grids.off("grid.afterRequest", onGridDataChanged).on("grid.afterRequest", onGridDataChanged);

        grids.each(function (ix0, grel) {
            const $gridId = $(grel).attr("data-id");

            const dfGridFsets = XPortal.DynamicFilters.GridFilterSetsPairs[$gridId] = { fsets: [], requests: [], responses: [], id: $gridId };
            allFilterSets.each(function (ix1, element) {
                let modelName = XPortal.Store.getModelName(element.id);
                let settings = XPortal.Store.GetModelByName(modelName).model.settings;

                let isExists = settings.influenceOnIds.length < 1 ? settings.parentId == $gridId : settings.influenceOnIds.find(v => v == $gridId);
                if (isExists) {
                    dfGridFsets.fsets.push(Object.assign({ modelName }, settings));
                }
            });
        });
        return XPortal.DynamicFilters.GridFilterSetsPairs;
    };
    function subscribeForChanges($fset, modelName) {
        const isAutoApply = $fset.find(".dynamic-filter-apply-button.autoapply").length !== 0;
        if (!isAutoApply) return;

        $fset.find(self.itemControlSelector).each(function (i, el) {
            let $el = $(el);
            let sttgs = XPortal.Main.GetSettingsFor($el);

            if (!sttgs.fieldname) {
                $el.find("input, select").each((ix, x) => {
                    sttgs = XPortal.Main.GetSettingsFor($(x));
                    if (sttgs.fieldname) { $el = $(x); }
                });
            }
            else {
                XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: $el },
                    (value) => {
                        clearTimeout(self.AutoApplyTimeouts[modelName]);
                        self.AutoApplyTimeouts[modelName] = setTimeout(() => onApply(null, false, $fset), 400);
                    },
                    (value) => { }
                );
            }
        });
    }
    function onApply(e = null, isReseted = false, $fset = null, modelName = null) {
        if (e) e.preventDefault();
        let $filterSet = $fset && $fset.length ? $fset : $(e.currentTarget).closest(self.fsetSelector);
        if ($filterSet.length) modelName = XPortal.Store.getModelName($filterSet.attr('id'));
        const fsmodel = modelName ? XPortal.Store.GetModelByName(modelName) : null;
        if (!$filterSet.length && fsmodel) $filterSet = $(fsmodel.model.selector);
        if (fsmodel && $filterSet.length) {
            fsmodel.model.IsApplied = !isReseted;
            fsmodel.model.entityApplied = Object.assign({}, fsmodel.entity);
            refreshSummaryModel(modelName);
            let influenceOnIds = getRelatedGridIds($filterSet);
            influenceOnIds.forEach(function (id) {
                let ginfo = XPortal.Grid.GetGridInfoById(id);
                cleanUpSearchCriteria(ginfo);
                setTimeout(function () {
                    ginfo.kgrid.dataSource.read();
                }, 300);
            });
        }
    };
    function onReset(e, fset) {
        if (e) e.preventDefault();
        fset = fset || $(e.currentTarget).closest(self.fsetSelector);
        resetFilters(fset);
        onApply(e, true, fset);
    };
    function resetFiltersBySummary(e) {
        let $el = $(e.currentTarget).closest(self.summaryItemSelector);
        let sumId = ($el.length ? $el : $(e.currentTarget)).attr("data-id");
        const model = self.SummaryViewModels.find(x => x.nodeId == sumId || x.shortKey == sumId);
        if (model) {
            $el = $el.length ? $el : $(_.find($(self.summaryItemSelector), x => $(x).attr("data-nodeid") == model.NodeId));
            searchFilterItems({ currentTarget: $el.find(".fs-filters-search") }, 500, "");
            model.filterSets.forEach(x => {
                onReset(null, $(x.selector));
            });
        }
    };
    function applyFiltersBySummary(e) {
        const $el = $(e.currentTarget).closest(self.summaryItemSelector);
        const sumId = ($el.length ? $el : $(e.currentTarget)).attr("data-id");
        const model = self.SummaryViewModels.find(x => x.nodeId == sumId || x.shortKey == sumId);
        if (model)
            model.filterSets.forEach(x => onApply(null, false, $(x.selector)));
    };
    function resetFilters($filterset) {
        const modelName = XPortal.Store.getModelName($filterset.attr('id'));
        const fsmodel = XPortal.Store.GetModelByName(modelName);
        fsmodel.entity.Fields.forEach((x, ix) => {
            XPortal.Store.DispatchNoAutoSave(modelName, x.Name, null);
        });
    };
    function resetFilter(e, fieldName, modelName, vtoremove) {
        const fsmodel = XPortal.Store.GetModelByName(modelName);
        let cval = XPortal.Template.GetObjPropValueByName(fsmodel.entity, fieldName);
        if (cval) {
            let cvals = cval.split ? cval.split("_#_") : [cval];
            cval = _.filter(cvals, v => v && v != vtoremove).join("_#_");
        }
        XPortal.Store.DispatchNoAutoSave(modelName, fieldName, cval);
        onApply(e, false, null, modelName);
    };
    function excludeDisplayValue(obj) {
        if (obj && obj.Fields) {
            obj.Fields.forEach(f => {
                const fvnm = XPortal.Template.GetObjPropName(f, "data");
                const fvvs = (f[fvnm] || "").split("_#_");
                f[fvnm] = fvvs.map(vi => {
                    const vidd = vi.split("d|d");
                    return vidd.length > 1 ? vidd[1] : vidd[0];
                }).join("_#_");
            });
        }
        return obj;
    };
    function prepareEntityForTemplate(entity) {
        const res = { Fields: [] };
        entity.Fields.forEach((x, ix) => {
            let f = Object.assign({}, x);
            f.Name = x.Name.slice(0, -8);
            res.Fields.push(f);
            res[f.Name] = entity[x.Name];
        });
        return res;
    };
    function getVMFieldValues(entity, fieldData, modelName) {
        const fieldName = fieldData.field;
        let vals = XPortal.Template.GetObjPropValueByName(entity, fieldName);
        if (!vals) return [];

        const field = entity.Fields.find(x => x.Name === fieldName.toLowerCase());
        const fieldMetaName = fieldName.slice(0, -8).toLowerCase();
        const preparedEntity = prepareEntityForTemplate(entity);
        const fieldType = (field.Type ? field.Type.toLowerCase() : "string") || "string";
        vals = vals.split ? vals.split("_#_") : [vals];
        return vals.map((vx, iv) => {
            preparedEntity[fieldMetaName] = vx;
            const v = fieldType.indexOf("bool") >= 0 || vx.includes('d|d') ? vx : XPortal.Grid.GetTemplateValue(preparedEntity, fieldType, fieldMetaName, fieldData.format, null, true);
            return {
                value: v && v.length ? v.split("d|d")[0] : v,
                showTitle: iv == 0 && !fieldData.hideTitle,
                title: fieldData.title,
                reset: (e) => resetFilter(e, fieldName, modelName, vx)
            };
        });
    };
    function lookupBeforeRequest($fset, e, data, request) {
        const el = $(e.target);
        data.fid = request.options.meta.fieldid;
        data.sid = request.options.meta.fsetid;
        data.grids = getFsetGridsInfo($fset);

        const modelName = XPortal.Store.getModelName($fset.attr('id'));
        const fsmodel = modelName ? XPortal.Store.GetModelByName(modelName) : null;
        const fsmfield = data.fid && (fsmodel ? fsmodel.model.fields.find(xf => data.fid.toLowerCase().indexOf(xf.id.toLowerCase()) >= 0) : null) || {};


        request.rejected = request.rejected || data.grids.length < 1;
        const ckey = data.grids.map(g => g.key).join("|");

        if (!request.rejected && data.grids.length) {
            request.rejected = !(fsmfield.lastRequestKey == null || fsmfield.lastRequestKey != ckey);
        }
        fsmfield.lastRequestKey = ckey;
    };
    function getFsetGridsInfo($fset) {
        var gids = getRelatedGridIds($fset);
        var grequests = [];
        gids.forEach(gid => {
            let gfp = getGridLatestRequestKey(gid);
            if (gfp) grequests.push(gfp);
        });
        return grequests;
    };
    function onGridDataChanged(e, $el, req, data, rawRes) {
        let ginfo = XPortal.Grid.GetGridInfo(e.target);
        let glinks = XPortal.DynamicFilters.GridFilterSetsPairs[ginfo.nodeId];
        clearTimeout(glinks.refreshTimeout);
        glinks.refreshTimeout = setTimeout(function () {
            let relFsetDatas = ginfo && ginfo.nodeId ? XPortal.DynamicFilters.GridFilterSetsPairs[ginfo.nodeId].fsets : [];
            updateGridResponseKey(ginfo.nodeId, rawRes.Key);
            relFsetDatas.forEach(fsd => {
                $fsblock = $(XPortal.Store.GetModelByName(fsd.modelName).model.selector);
                self.UpdateLookupsAndPickers($fsblock);
            });
        }, 500);
    };
    function cleanUpSearchCriteria(ginfo) {
        let relFsetDatas = ginfo && ginfo.nodeId ? XPortal.DynamicFilters.GridFilterSetsPairs[ginfo.nodeId].fsets : [];
        relFsetDatas.forEach(fsd => {
            $fsblock = $(XPortal.Store.GetModelByName(fsd.modelName).model.selector);
            $fsblock.find(".fs-filters-search").each((sfix, sfx) => {
                if (!$(sfx).val()) return;
                searchFilterItems({ currentTarget: sfx }, 1, "");
            });
            self.SummaryViewModels.filter(sm => sm.fsModelNames.find(fsi => fsi == fsd.modelName)).forEach(smi => {
                let $el = $(_.find($(self.summaryItemSelector), x => $(x).attr("data-nodeid") == smi.nodeId));
                $el.find(".fs-filters-search").each((sfix, sfx) => {
                    if (!$(sfx).val()) return;
                    searchFilterItems({ currentTarget: sfx }, 1, "");
                });
            });
        });
    };
    function updateGridResponseKey(gridId, key, data) {
        if (gridId && key) {
            let gfrel = XPortal.DynamicFilters.GridFilterSetsPairs[gridId];
            gfrel.responses.push(Object.assign({}, data, { "___id___": moment().format("HH:mm:ss.SSS"), key }));
            while (gfrel.responses.length > 3) gfrel.responses.shift();
        }
    };
    function updateGridRequestKey(gridId, key, data) {
        if (gridId && key && data) {
            let gfrel = XPortal.DynamicFilters.GridFilterSetsPairs[gridId];
            gfrel.requests.push(Object.assign({}, data, { "___id___": moment().format("HH:mm:ss.SSS"), key }));
            while (gfrel.requests.length > 3) gfrel.requests.shift();
        }
    };
    function getGridLatestRequestKey(gridId) {
        if (!gridId) return null;
        let gfp = XPortal.DynamicFilters.GridFilterSetsPairs[gridId];
        if (!gfp) return null;
        let rt = gfp.responses && gfp.responses.length ? Object.assign({}, gfp.responses[gfp.responses.length - 1]) : null;
        let rq = gfp.requests && gfp.requests.length ? Object.assign({}, gfp.requests[gfp.requests.length - 1]) : { nodeid: gridId };
        return rt ? Object.assign({}, rq, rt) : null;
    };
    function getRelatedGridIds($filterset) {
        let res = [];
        const fsId = $filterset.attr("data-id");
        for (var grId in XPortal.DynamicFilters.GridFilterSetsPairs) {
            let fsGrInfo = XPortal.DynamicFilters.GridFilterSetsPairs[grId];
            let exitem = (fsGrInfo.fsets || []).find(fsi => fsi.nodeId == fsId);
            if (exitem && exitem.nodeId == fsId) res.push(grId);
        }
        return res;
    };
    function initSummaries($container, allFilterSets) {
        moveClearFiltersBtnTitle($container);
        moveApplyFiltersBtnTitle($container);

        checkToHideSummaryHeader($container); // hide summary header if parent section collapsible and summary does not have title and parent section is not tab
        $container.off('keyup', '.fs-filters-search', searchFilterItems);
        $container.on('input', '.fs-filters-search', searchFilterItems);

        const rsel = '.fs-summary-reset-button, .dynamic-filter-summary .dynamic-filter-reset-button, .dynamic-filter-summary_items .dynamic-filter-reset-button';
        const asel = '.fs-summary-apply-button, .dynamic-filter-summary .dynamic-filter-apply-button, .dynamic-filter-summary_items .dynamic-filter-apply-button';
        $container.off('click', rsel, resetFiltersBySummary).on('click', rsel, resetFiltersBySummary);
        $container.off('click', asel, applyFiltersBySummary).on('click', asel, applyFiltersBySummary);

        initSummaryBlocks($container, allFilterSets);
        initSummaryItems(allFilterSets);
    };
    function moveClearFiltersBtnTitle($container) {
        const $summaryHeaders = $container.find('.filter-set-summary__header');

        $summaryHeaders.each(function () {
            const $summaryHeader = $(this);
            const $summaryFiltersSectionParent = $summaryHeader.closest('.xsection');
            const $summaryFiltersSectionParentHeader = $summaryFiltersSectionParent.find('> .xbgdecoration-wrap > .block-header');
            const $summaryFiltersSectionParentHeaderTitle = $summaryFiltersSectionParentHeader.find('.block-header-title');
            const isSectionCollapsible = $summaryFiltersSectionParent.hasClass('collapsible');
            const isTabSection = $summaryFiltersSectionParent.hasClass('xsection-tab');
            const $summaryHeaderTitle = $summaryHeader.find('.filter-set-summary__header-title');
            const isSummaryHeaderTitleApplied = $summaryHeaderTitle.html().trim() !== "";
            const $resetBtnClone = $summaryHeader.find('.fs-summary-reset-button'); //.clone();
            const isFiltersWide = $summaryFiltersSectionParent.is('.col-12');

            if (!isSummaryHeaderTitleApplied && !isTabSection) {
                $summaryFiltersSectionParentHeader.addClass('with-fs-summary-reset-button');
                const widthResetButton = $resetBtnClone.outerWidth(true);
                const widthcCollapseButton = $summaryFiltersSectionParent.find('.collapse-buttons').outerWidth(true);
                const headerPadding = Math.round(widthResetButton + widthcCollapseButton + 30);

                if (widthcCollapseButton && isFiltersWide) {
                    $summaryFiltersSectionParentHeader.css('padding-right', headerPadding);
                }

                $summaryFiltersSectionParentHeaderTitle.after($resetBtnClone);
            }
        });
    }
    function checkToHideSummaryHeader($container) {
        const $summaryHeaders = $container.find('.filter-set-summary__header');
        $summaryHeaders.each(function () {
            const $summaryHeader = $(this);
            const $summaryFiltersSectionParent = $summaryHeader.closest('.xsection');
            const isSectionCollapsible = $summaryFiltersSectionParent.hasClass('collapsible');
            const isTabSection = $summaryFiltersSectionParent.hasClass('xsection-tab');
            const $summaryHeaderTitle = $summaryHeader.find('.filter-set-summary__header-title');
            const isSummaryHeaderTitleApplied = $summaryHeaderTitle.html().trim() !== "";

            if (isSectionCollapsible && !isSummaryHeaderTitleApplied && !isTabSection)
                $summaryHeader.addClass('d-none');
        });
    }
    function moveApplyFiltersBtnTitle($container) {
        const $applyBtnWrappers = $container.find('.is-section-header .dynamic-filter-button-wrp');

        $applyBtnWrappers.each(function () {
            const $applyBtnWrapper = $(this);
            const $summaryFiltersSectionParent = $applyBtnWrapper.closest('.xsection');
            const isWideContainer = $summaryFiltersSectionParent.hasClass('fs-wide-container');

            const $applyBtnTopPlusTitle = $summaryFiltersSectionParent.find('>.xbgdecoration-wrap:has(> .block-header) .filter-set-summary__header');
            const $clearBtn = $summaryFiltersSectionParent.find('.fs-summary-reset-button.dfilter-reset-top');
            
            if (isWideContainer) {
                if ($clearBtn.length && $applyBtnTopPlusTitle.length) {
                    const clearBtnWidth = Math.round($clearBtn.outerWidth() + 24);
                    $applyBtnTopPlusTitle.css('right', clearBtnWidth);
                }
                
                return true; 
            }

            const $applyBtn = $applyBtnWrapper.find('.btn');
            if ($summaryFiltersSectionParent.is('.col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, col-12')) {
                $applyBtn.addClass('w-auto');
            }
            const $summaryFiltersSectionParentHeader = $summaryFiltersSectionParent.find('> .xbgdecoration-wrap > .block-header');
            const $summaryFiltersSectionParentTitleWrp = $summaryFiltersSectionParentHeader.find('.block-header__title-wrp');
            const $summaryFiltersSectionParentTitle = $summaryFiltersSectionParentTitleWrp.find('.block-header-title');
            const $summaryFiltersSectionParentResetBtn = $summaryFiltersSectionParentTitleWrp.find('.fs-summary-reset-button');
            const availableWidth = $summaryFiltersSectionParentHeader.width() - $summaryFiltersSectionParentTitle.width() - $summaryFiltersSectionParentResetBtn.width();
            const applyBtnWidth = $applyBtn.width();
            const isSectionCollapsible = $summaryFiltersSectionParent.is('.collapsible');
            const isTabSection = $summaryFiltersSectionParent.hasClass('xsection-tab');
            const $applyBtnClone = $applyBtn.clone();
            $applyBtnClone.addClass('dynamic-filter-apply-button_in-title');

            if (!isTabSection && !isWideContainer) {
                $applyBtnWrapper.remove();
                
                if ($summaryFiltersSectionParentHeader.length > 0) {
                    $summaryFiltersSectionParentHeader.addClass('with-fs-summary-reset-button');
                    $summaryFiltersSectionParentTitle.after($applyBtnClone);
                } else {
                    $summaryFiltersSectionParent.find('.is-section-header').first().prepend($applyBtnClone);
                    $summaryFiltersSectionParent.addClass('with-fs-summary-reset-button_no-header');
                }
                
                $summaryFiltersSectionParent.addClass('xsection_apply-btn-in-header');
            } 
            checkWidthAndMoveElements($summaryFiltersSectionParent);
        });
    }

    function checkWidthAndMoveElements($summaryFiltersSectionParent) {
        if ($summaryFiltersSectionParent.is('.col-1, .col-2, .col-3, .col-4')) {
            const $blockHeaderWrapper = $summaryFiltersSectionParent.find('.block-header__title-wrp').first();
            if (!$blockHeaderWrapper.length) return;

            const $blockTitle = $blockHeaderWrapper.find('.block-header-title');
            const $clearBtn = $blockHeaderWrapper.find('.fs-summary-reset-button.dfilter-reset-top');
            const widthDiff = $blockHeaderWrapper.outerWidth() - $clearBtn.outerWidth() - $blockTitle.outerWidth();

            if (widthDiff < 110) {
                if ($blockTitle.length && $clearBtn.length && !$blockTitle.parent().hasClass('title-left-side')) {
                    $blockTitle.add($clearBtn).wrapAll('<div class="title-left-side"></div>');
                }
            } else {
                if ($blockTitle.length && $blockTitle.parent().hasClass('title-left-side')) {
                    $blockTitle.unwrap();
                }
            }
        }
    };

    function getHiddenElementWidth(element) {
        const clonedElement = element.cloneNode(true);
        clonedElement.style.visibility = 'hidden';
        clonedElement.style.position = 'absolute';
        document.body.appendChild(clonedElement);
        const height = clonedElement.offsetHeight;
        document.body.removeChild(clonedElement);
        return height;
    };

    function refreshSummaryModel(lactionModel, timeinterval = 100) {
        if (!lactionModel) return;
        self.SummaryViewModels.forEach(sx => {
            if (!sx.fsModelNames.find(fx => fx == lactionModel)) return;
            clearTimeout(sx.refreshTimeout);
            sx.refreshTimeout = setTimeout(function () {
                let iindex = 0;
                let findex = 0;
                let maxtoShow = sx.tags.maxValsToShow ? sx.tags.maxValsToShow : 10000;
                sx.tags.hidden = 0;
                sx.filterSets.forEach(fs => {
                    const fsmodel = XPortal.Store.GetModelByName(fs.modelName);
                    if (!fsmodel.model.entityApplied) return;
                    const startiindex = iindex;
                    fs.fields.forEach((x, ix) => {
                        const v = [];
                        findex++;
                        getVMFieldValues(fsmodel.model.entityApplied, x, fs.modelName).forEach((vi, vix) => {
                            iindex++;
                            vi.hidden = iindex > maxtoShow;
                            vi.index = iindex;
                            v.push(vi);
                        });
                        XPortal.Utils.updateKendoObj(x, { value: v, count: v.length, hideCount: true, isNotSel: !isSel(x, v), showTitle: ix == 0 });
                        XPortal.Utils.updateKendoObj(x, { count: XPortal.Template.TemplateToHtml(x, x.tformat), hideTitle: sx.tags.showCaptions && x.summshowcaption == 1 ? false : true, isHidden: isHiddenSummaryFieldItem(x, sx, ix, startiindex) });
                    });
                });
                XPortal.Utils.updateKendoObj(sx, { count: iindex - maxtoShow, hideShowMore: maxtoShow >= iindex });
                XPortal.Utils.updateKendoObj(sx, { showMoreText: XPortal.Template.TemplateToHtml(sx, sx.tags.showMoreFormat || "") });
                if (iindex <= maxtoShow) XPortal.Utils.updateKendoObj(sx, { hideTagsSimple: false, hideTagsDetail: true });
            }, timeinterval);
        });
    }
    function isHiddenSummaryFieldItem(d, sm, ix, iidx) {
        d = d || this;
        if (d.isNotSel) return true;
        if (!sm.tags.maxValsToShow) return false;
        if (sm.tags.maxValsToShow <= iidx) {
            sm.tags.hidden++;
            return true;
        }
        return false;
    };
    function isSel(d, v) {
        d = d || this;
        v = v || d.value;
        if (!(d.summaryshow != "1" || !v || !v.length)) return true;
        return false;
    };
    function initSummaryItems(allFilterSets) {
        allFilterSets.each(function (ix, el) {
            const summaries = $(el).find(self.summaryItemSelector);
            if (!summaries.length) return;
            const sttgs = XPortal.Utils.readJsonStr(summaries.attr("data-settings"), {});
            const modelName = XPortal.Store.getModelName(el.id);
            const model = XPortal.Store.GetModelByName(modelName).model;
            model.modelName = modelName;
            const viewModel = kendo.observable({ nodeId: model.NodeId, filterSets: [model], fsModelNames: [modelName], showMoreText: "", hideShowMore: true, hideTagsSimple: false, hideTagsDetail: true, toggleTagsView, tags: sttgs.tags || {}, shortKey: sttgs.shortKey });
            summaries.each(function (i, summary) { kendo.bind($(summary), viewModel); });
            self.SummaryViewModels.push(viewModel);
        });
    };
    function initSummaryBlocks($container, allFilterSets) {
        $container.find(self.summaryBlockSelector).each(function (i, el) {
            const $el = $(el);
            const sttgs = XPortal.Utils.readJsonStr($el.attr("data-settings"), {});
            let models = [], modelsNames = [];
            for (var i in XPortal.Store.GetState().pageModels) {
                const m = XPortal.Store.GetState().pageModels[i];
                const fsid = m.model && m.model.isFilterSet ? m.model.NodeId : null;
                if (!sttgs.influenceOnIds.length || sttgs.influenceOnIds.find(id => id == fsid)) {
                    modelsNames.push(i);
                    m.model.modelName = i;
                    models.push(m.model);
                }
            }
            const viewModel = kendo.observable({ nodeId: sttgs.nodeId, filterSets: models, fsModelNames: modelsNames, showMoreText: "", hideShowMore: true, hideTagsSimple: false, hideTagsDetail: true, toggleTagsView, tags: sttgs.tags || {}, shortKey: sttgs.shortKey });
            kendo.bind($el, viewModel);
            self.SummaryViewModels.push(viewModel);
        });
    };
    function toggleTagsView() {
        let self = this;
        XPortal.Utils.updateKendoObj(self, {
            hideTagsSimple: !self.hideTagsSimple,
            hideTagsDetail: self.hideTagsSimple
        });
    };
    function searchFilterItems(e, timeoutVal = 500, valTosetup) {
        let $searchField = $(e.currentTarget), val = ($searchField.val() || "").toLowerCase().trim();
        if (valTosetup || valTosetup == '') $searchField.val(val = valTosetup);
        const parent = $searchField.closest(self.summaryItemSelector), nodeId = parent.attr("data-nodeId");
        const smodel = nodeId ? self.SummaryViewModels.find(x => x.nodeId == nodeId) : null;
        if (!smodel) return;
        smodel.requestId = new Date().getTime();

        function onSearch(rId) {
            if (rId && rId < smodel.requestId) return;
            clearTimeout(smodel.searchTimeout);
            smodel.searchTimeout = setTimeout(function () {
                let oneFSetBlockHasSearchField = false;
                smodel.filterSets.forEach(fsetModel => {
                    const fsblock = $(fsetModel.selector);
                    const fsblockItems = _.map(fsblock.find(self.itemsWithEditorSelector), fsbi => { return { el: $(fsbi), stgs: XPortal.Main.GetSettingsFor(fsbi), a: $(fsbi).addClass("d-none") == true }; });
                    const fieldsWithTexts = fsetModel.fields.filter(x => findValInField(x, val, fsetModel, fsblock, fsblockItems));
                    fieldsWithTexts.forEach(x => {
                        const visibleEls = fsblockItems.filter(fsbi => fsbi.stgs.id == x.id);
                        visibleEls.forEach(vx => {
                            vx.el.removeClass("d-none");
                            showHideFieldTile(x, vx, val);
                        });
                    });

                    const $moreWrp = fsblock.find(self.groupMoreBtnWrp);
                    val !== '' ? $moreWrp.addClass('d-none') : $moreWrp.removeClass('d-none');
                    if (fsblock.has($searchField).length) oneFSetBlockHasSearchField = true;
                    else showHideSectionBlock(fsblock.closest(self.fsetSectionSelector), someDel => isPartOfSummary(smodel, parent, someDel));
                    fsblock.find(self.groupControlSelector).each((ixg, xg) => showHideSearchBlock(xg, $searchField));
                    if (!rId) {
                        fsblock.find(XPortal.MValuePiker.controlSelector).each((xi, xv) =>
                            $(xv).trigger("search.execute", { search: val, onresult: function () { onSearch(smodel.requestId); } })
                        );
                    }
                });
                if (!oneFSetBlockHasSearchField)
                    parent.closest(self.summaryBlockSelector).find(".xfiltersummarysection").each((ixg, xg) => showHideSectionBlock(xg, someDel => isPartOfSummary(smodel, parent, someDel)));
            }, timeoutVal);
        };
        onSearch();
    };
    function isPartOfSummary(smodel,sel, el) {
        if (jQuery.contains(sel, el)) return true;
        var parentFset =  smodel.filterSets.find(fsetModel => {
            const fsblock = $(fsetModel.selector);
            if (jQuery.contains(fsblock, el)) return true;
            return false;
        });
        if (parentFset == null) return false;
        return true;
    };
    function showHideFieldTile(xf, x, val) {
        const tls = x.el.find(".p-tile");
        tls.addClass("d-none");
        _.each(tls, tx => {
            if ($(tx).text().trim().toLowerCase().indexOf(val) > -1)
                $(tx).removeClass("d-none");
        });
    };
    function findValInField(f, val, model, block, blockfields) {
        var xkeywds = val.split(" ");
        let r = findKeywordIn(model.searchmeta, xkeywds);
        if (r > -1) return true;
        r = findKeywordIn(f.title, xkeywds);
        if (r > -1) return true;
        r = findKeywordIn(f.stitle, xkeywds);
        if (r > -1) return true;
        r = f.value.find(v => findKeywordIn(v ? String(v) : "", xkeywds) > -1) ? 0 : -1;
        if (r > -1) return true;
        r = f.value.find(v => findKeywordIn(v && v.value ? String(v.value) : "") > -1) ? 0 : -1;
        if (r > -1) return true;
        r = searchValInFieldsHtml(f, val, blockfields, xkeywds);
        return r > -1;
    };
    function findKeywordIn(txt, keywds) {
        if (!txt || !txt.length) return -1;
        txt = txt.toLowerCase().trim();
        if (!txt.length) return -1;
        for (var i = 0; i < keywds.length; i++) {
            const keywd = (keywds[i] || "").trim();
            const k = txt.indexOf(keywd);
            if (k > -1) return k;
        }
        return -1;
    }
    function searchValInFieldsHtml(f, val, blockfields, xkeywds) {
        if (!blockfields) return -1;
        const elf = blockfields.find(x => x.stgs.id == f.id);
        if (!elf || !elf.el) return -1;
        let txt = (elf.el.text() || "").trim().toLowerCase();
        if (!txt || txt == "") {
            const ddel = _.find(elf.el.find(".xpand-dropdown").map((xi, x) => $(x).data("kendoComboBox")), x => x != null);
            txt = (ddel && ddel.list ? ddel.list.text() || "" : "").trim().toLowerCase();
        }
        return findKeywordIn(txt, xkeywds);
    };
    function showHideSectionBlock(bel, checkIsPartOfSearchPanel) {
        const $gel = bel ? $(bel) : $(this);
        const isVisible = _.filter($gel.find(self.itemsWithEditorSelector), x => !$(x).hasClass("d-none"));
        if (checkIsPartOfSearchPanel($gel) == false) return;
        toggleDynamicItem(isVisible, $gel, '.nav-item', '.tab-pane', checkIsPartOfSearchPanel);
        toggleDynamicItem(isVisible, $gel, '.dropdown-item', '.xportal-dd-panel', checkIsPartOfSearchPanel);
        toggleDynamicItem(isVisible, $gel, '.accordion-item', '.accodion-panel', checkIsPartOfSearchPanel);
        isVisible.length ? $gel.removeClass("d-none") : $gel.addClass("d-none", checkIsPartOfSearchPanel);
    };
    function showHideSearchBlock(bel, $searchField) {
        const $gel = bel ? $(bel) : $(this);
        const isVisible = _.filter($gel.find(self.itemsWithEditorSelector), x => !$(x).hasClass("d-none"));
        const hasSblock = $gel.has($searchField).length;
        if (isVisible.length || hasSblock) $gel.removeClass("d-none");
        else $gel.addClass("d-none");
        return hasSblock;
    };
    function getInputTextWidth(input, defaultText) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const style = getComputedStyle(input);
        ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

        return ctx.measureText(defaultText || input.value).width;
    }
    function toggleDynamicItem(isVisible, $section, headerSelector, contentSelector, checkIsPartOfSearchPanel) {
        let $tabContent = $section.closest(contentSelector);
        if (checkIsPartOfSearchPanel($tabContent) == false) return;
        if ($tabContent.length) {
            const tabContentHeaderId = $tabContent.attr('aria-labelledby');
            if (isVisible.length) {
                $section.removeClass('d-none');
                $tabContent.removeClass('d-none');
                $(`#${tabContentHeaderId}`).closest(headerSelector).removeClass('d-none');
            }
            else {
                $section.addClass('d-none');
                $tabContent.addClass('d-none');
                const $tabTitle = $(`#${tabContentHeaderId}`).closest(headerSelector);
                $tabTitle.addClass('d-none');
                setTimeout(() => {
                    headerSelector !== '.accordion-item'
                        ? $tabTitle.parent().children(':not(.d-none)').first().find('.dynamic-blick-title').trigger('click') //to activate first visible item
                        : $tabTitle.closest('.accordion-section').children('.border-bottom').children('.accordion-item:not(.d-none)').first().find('.dynamic-blick-title:not([aria-expanded="true"])').trigger('click'); //to activate first visible item
                }, 0);
            }
        }
    };
    return self;
}());
